module.exports = __webpack_public_path__ + "img/ปลากระพง.67b19a8c.jpg";